import { render, staticRenderFns } from "./jingzhengli.vue?vue&type=template&id=225d88f7&scoped=true&"
import script from "./jingzhengli.vue?vue&type=script&lang=js&"
export * from "./jingzhengli.vue?vue&type=script&lang=js&"
import style0 from "./jingzhengli.vue?vue&type=style&index=0&id=225d88f7&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225d88f7",
  null
  
)

export default component.exports